export const wrapLoadingAction = async <T extends any = void>(
  callback: () => Promise<T>,
  setLoading: (isLoading: boolean) => void,
  onError?: (error: Error) => void
): Promise<T | null> => {
  try {
    setLoading(true);

    const result = await callback();
    return result;
  } catch (error) {
    if (!onError) {
      throw error;
    }
    onError(error as Error);
  } finally {
    setLoading(false);
  }
  return null;
};
